import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  user: any | null;
  isAuthenticated: boolean;
  userRole: any | null;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  userRole: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,

  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.userRole = action.payload.role;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.userRole = null;
    },
  },
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
